<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'lpss') {
            next({ name: 'lps-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'lpss') {
            this.$router.push({ name: 'lps-list' });
        }
    },
};
</script>
